import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  footer: {
      width: theme.spacing(10),
      height: theme.spacing(10),
  },
  paper: {
      marginTop: theme.spacing(4),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      bottom: 0,
      position: 'sticky'
  },
}));

export default function Copyright() {
    const classes = useStyles();
    return (
      <div className={classes.paper}>
        <Typography variant="body2" color="textSecondary" align="center">
          {'Copyright © '} {new Date().getFullYear()} {' '}
          <Link color="inherit" href="https://www.jababeka.com/" target="_blank">
            Kawasan Industri Jababeka
          </Link>
          {'.'}
        </Typography>
      </div>
    );
  }